// utils/blanksexport.js
export function generateBlankReport(frmData = {}, currentUser = null) {
  let report = "";
  const impression = [];

  report += `
      <div style="border: 1px solid #ccc; padding: 8px; border-radius: 6px;">
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td><b>Name:</b> ${frmData.NameTextFR2 || ""}</td>
            <td><b>Patient ID:</b> ${frmData.IDTextFR2 || ""}</td>
            <td><b>Age:</b> ${frmData.AgeTextFR2 || ""}</td>
          </tr>
          <tr>
            <td><b>Gender:</b> ${frmData.GenderTextFR2 || ""}</td>
            <td><b>Test Date:</b> ${frmData.TestDateTextFR2 || ""}</td>
            <td><b>Report Date:</b> ${frmData.ReportDateTextFR2 || ""}</td>
          </tr>
          <tr>
            <td colspan="2"><b>Referring Doctor:</b> ${frmData.ReferralDoctorTextFR2 || ""}</td>
            <td><b>Report Time:</b> ${frmData.ReportTimeTextFR2 || ""}</td>
          </tr>
        </table>
      </div>
      <br>
    `;

  // ✅ Report title
  // report += `
  //   <p style="text-align: center;">
  //     <strong><u>GENERAL REPORT</u></strong>
  //   </p>
  //   <h5><strong><u>OBSERVATIONS:</u></strong></h5>
  // `;

  // ✅ Optional fields
  // if (frmData.description) {
  //   report += `<p>${frmData.description}</p>`;
  //   impression.push(frmData.description);
  // }

  // if (frmData.measurements) {
  //   report += `<p><strong>Measurements:</strong> ${frmData.measurements}</p>`;
  // }

  // if (frmData.recurrence) {
  //   report += `<p><strong>Recurrence:</strong> ${frmData.recurrence}</p>`;
  // }

  // if (frmData.rating) {
  //   report += `<p><strong>Rating:</strong> ${frmData.rating}/5</p>`;
  // }

  // if (frmData.reportimage) {
  //   report += `
  //     <div style="margin-top: 10px;">
  //       <img src="${frmData.reportimage}" alt="Report Image" style="max-width: 100%; border: 1px solid #ccc;" />
  //     </div>
  //   `;
  // }

  // ✅ Impression section
  // report += `
  //   <p><strong><u>IMPRESSION:</u></strong></p>
  //   <p>${impression.length ? impression.join(", ") : "No significant findings."}</p>
  // `;

  // ✅ Signature block
  if (currentUser && currentUser.signature) {
    report += `
      <div style="margin-top: 30px; text-align: right;">
        <img src="${currentUser.signature}" alt="Signature" style="height: 75px;" />
        <p style="margin: 0;">
          <b>${currentUser.full_name || ""}</b><br>
          ${currentUser.designation || ""}
        </p>
      </div>
    `;
  }

  return report;
}
